import { useContext } from "react";
import APIContext from "../context/api-context/api-context";
import API from "../api/api";






export const useAPI = (): API => {
  const context = useContext(APIContext);
  if (!context) throw new Error("useAPI must be used within an APIProvider");
  return context.api;
};